export const addPdfFooter = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    doc.setFontSize(8);
    doc.setTextColor(120);

    const y = pageHeight - 8;

    // --- Texts ---
    const text1 = "© WheelsERP";
    const text2 = " Prime";

    // --- Measure width of first text ---
    doc.setFont(undefined, "bold");
    const text1Width = doc.getTextWidth(text1);

    // --- Right aligned start position ---
    const startX = pageWidth - 10 - (text1Width + doc.getTextWidth(text2));

    // --- Draw WheelsERP (bold) ---
    doc.text(text1, startX, y);

    // --- Draw Prime (italic) AFTER WheelsERP ---
    doc.setFont(undefined, "italic");
    doc.text(text2, startX + text1Width, y);
  }
};
